export default {
  headersEtag: {}
}
